<template>
  <div class="yj-breadcrumb" aria-label="Breadcrumb" role="navigation">
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: 'YjBreadcrumb',

    props: {
      separator: {
        type: String,
        default: '/'
      },
      separatorClass: {
        type: String,
        default: ''
      }
    },

    provide() {
      return {
        yjBreadcrumb: this
      };
    },

    mounted() {
      const items = this.$el.querySelectorAll('.yj-breadcrumb__item');
      if (items.length) {
        items[items.length - 1].setAttribute('aria-current', 'page');
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/breadcrumb/src/breadcrumb.vue